import React, { useEffect, useState } from 'react'
import { http } from '../utils/api'
import { Alert } from 'antd'

const UsageBanner = () => {
  const [usage, setUsage] = useState({
    monthlyOrderCount: 0,
    resetDate: null,
    heroPlan: false,
  })

  const [loading, setLoading] = useState(false)

  const fetchUsage = async () => {
    try {
      setLoading(true)
      const { data } = await http.get('/api/shop/usage.json')
      setUsage(data)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(async () => {
    await fetchUsage()
  }, [])

  const message = (
    <>
      {usage.monthlyOrderCount > 50 ? (
        <>
          <p>You have used all 50 invoices. A usage fee has been charged to your account, but now you can send invoices for unlimited orders for the rest of this billing cycle.</p>
          <p>Your invoice limit will reset on {usage.resetDate}</p>
        </>
      ) : (
        <>
          You've used {usage.monthlyOrderCount}/50 free invoices on the Pay as you go plan for this billing cycle. Your limit will reset on {usage.resetDate}.
        </>
      )}
    </>
  )

  return (
    <>
      {loading || !usage.heroPlan ? null : (
        <Alert banner message={message} type="info" />
      )}
      {/* {!loading && <Alert banner message="We're currently experiencing issues with automatic invoice email deliveries. Our team is working to resolve this as quickly as possible. 
      Thank you for your patience." type="info" /> } */}
      {/* react-fast-marquee yarn package is required to run this banner*/}
      {/* {!loading && <Alert banner message={<Marquee pauseOnHover gradient={false}>Our application will be unavailable due to scheduled maintenance on 11 April 2025, between 1:00 AM and 4:00 AM UTC. 
      We apologize for any inconvenience and appreciate your understanding.</Marquee>} type="warning" />} */}
    </>
  )
}

export default UsageBanner
